// extracted by mini-css-extract-plugin
export default {"detailSection":"CoffeeAccesoriesAbout_detailSection__nHB0-"};